package org.chiangmeng.qfast.core.domain.usecases

import org.chiangmeng.qfast.core.domain.ports.QueueRepository

class ResetQueueUseCase(private val repository: QueueRepository) {
    suspend operator fun invoke(shopId: String) {
        repository.resetQueue(shopId)
    }
}